export default __webpack_public_path__ + "static/media/hands.c8de2fd5.svg";